<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Name')" />
          <textarea-input v-model="form.description" :error="form.errors.description" :rows="8" class="pb-6 w-full lg:w-1/2" placeholder="description here.." :label="__('Description')"></textarea-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create Data') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

      <script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Create a New Asset Category' },
  components: {
    LoadingButton,
    TextInput,
    TextareaInput,
    Head,
  },
  layout: Layout,
  props: {
    title: String,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        description: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('asset_category.store'))
    },
  },
}
</script>
